module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_06@2x-d3a66de7a343e83b1e1863adb0ee0e5b.webp";